import colors from 'vuetify/es5/util/colors';

var themes = {
  light: {
    primary: '#1f337d',
    secondary: '#F4F4F5',
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber,
  },
  dark: {
    primary: colors.blue.darken2,
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber,
  },
};
switch (window.env.VUE_APP_AMBIENTE) {
  case 'americanas':
    themes = {
      light: {
        primary: '#BC0033',
        secondary: '#FD6310',
        accent: '#454545',
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber,
      },
    };
    break;
  case 'bmp_scm':
    themes = {
      light: {
        primary: '#1f337d',
        secondary: '#FD6310',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber,
      },
    };
    break;
}

let background = '/assets/imgs/background.svg';
let logo = '/assets/imgs/logo.svg';

try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/background.svg');
    background = '/assets/imgs/' + localStorage.ambiente + '/background.svg';
  }
} catch {}
try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/logo.svg');
    logo = '/assets/imgs/' + localStorage.ambiente + '/logo.svg';

    var favicon = document.getElementById('custom-favicon');
    favicon.setAttribute(
      'href',
      '/assets/imgs/' + localStorage.ambiente + '/favicon.svg'
    );
  }
} catch {}

var headerColor = themes.light.primary;
var logoHeaderHome = 'assets/imgs/' + localStorage.ambiente + '/logo.svg';
var backgroundHome = null;
var button = {
  color: '#F4F4F5',
  class: 'primary--text',
};
switch (window.env.VUE_APP_AMBIENTE) {
  case 'americanas':
    headerColor = 'white';
    backgroundHome = 'assets/imgs/americanas/background.svg';
    break;
  case 'bmp_scm':
    headerColor = 'white';
    backgroundHome = 'assets/imgs/background.svg';
    break;
}

export default {
  dark: false,
  options: {
    customProperties: true,
    dense: false,
    toolbar: { color: headerColor },
    home: {
      button: button,
    },
    logoHeaderHome,
    backgroundHome,
  },
  background,
  logo,
  themes: themes,
};
